<div class="input-group">
  <span class="input-group-text">
    <i class="fa-light fa-magnifying-glass"></i>
  </span>
  <input 
    #searchInput
    type="search" 
    class="form-control" 
    [placeholder]="placeholder()"
    [attr.aria-label]="ariaLabel()"
    autocomplete="off"
    [(ngModel)]="searchText"
    (ngModelChange)="onSearchChange($event)">
</div>